export const userKeys = {
  all: ["users"] as const,
  list: (params: { page: number; limit: number }) =>
    ["users", "list", params] as const,
  pendingInvites: () => ["users", "pendingInvites"] as const,
};

export const configKeys = {
  all: ["config"] as const,
};
